import { useDispatch, useSelector, useStore } from 'react-redux';
import type { AppDispatch, AppStore, RootState } from './store';

/**
 * Represents a typed version of useDispatch.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

/**
 * Represents a typed version of useSelector.
 */
export const useAppSelector = useSelector.withTypes<RootState>();

/**
 * Represents a typed version of useStore.
 */
export const useAppStore = useStore.withTypes<AppStore>();
